import { render, staticRenderFns } from "./CardDocumentsMain.vue?vue&type=template&id=f4128bc8&scoped=true&"
import script from "./CardDocumentsMain.vue?vue&type=script&lang=js&"
export * from "./CardDocumentsMain.vue?vue&type=script&lang=js&"
import style0 from "./CardDocumentsMain.vue?vue&type=style&index=0&id=f4128bc8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4128bc8",
  null
  
)

export default component.exports